
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-58d7f15b&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./UserProfile.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./UserProfile.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-58d7f15b!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserProfile.vue"),
  /* scopeId */
  "data-v-58d7f15b",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/UserProfile/UserProfile.vue
// module id = 658
// module chunks = 0